<template>
    <modal :name="name"
           :height="height"
           :width="width"
           :maxWidth="maxWidth"
           :pivotY="0.3"
           :adaptive="adaptive"
           :resizable="resizable"
           :draggable="draggable"
           :scrollable="scrollable"
           :clickToClose="clickToClose"
           :minHeight="200"
           @opened="onOpened"
           @closed="onClosed"
           v-on="{
               'before-open': beforeOpen ? beforeOpen : () => {},
               'before-close': beforeClose ? beforeClose : () => {}
           }">
        <div :id="name"
             :tabindex="tabindex"
             class="modal-container">

            <h3 class="app-modal-header">
                <slot name="header"/>
            </h3>

            <div class="app-modal-content">
                <slot name="content"/>

                <div class="app-modal-actions">
                    <slot name="actions"/>
                </div>
            </div>
        </div>

        <slot name="modals"/>

    </modal>
</template>

<script>
export default {
    name: 'AppModal',
    props: {
        name: {
            type: String,
            required: true
        },
        height: {
            default: 'auto'
        },
        width: {
            default: 600
        },
        maxWidth: {
            default: Infinity
        },
        resizable: {
            type: Boolean,
            default: false
        },
        adaptive: {
            type: Boolean,
            default: true
        },
        clickToClose: {
            type: Boolean,
            default: true
        },
        draggable: {
            type: Boolean,
            default: false
        },
        scrollable: {
            type: Boolean,
            default: true
        },
        beforeClose: {
            type: Function
        },
        beforeOpen: {
            type: Function
        },
        opened: {
            type: Function
        },
        /**
         * tabindex used for modals stack
         * (correct focus current modal and onEnterKeyPress binding)
         * 0 - for lowest modal
         * 1 - for higher, etc.
         * */
        tabindex: {
            type: Number,
            default: 0
        },
        onEnterKeyPress: {type: Function} // bind modal action on enter press
    },
    methods: {
        onOpened() {
            if (this.opened) {
                this.opened()
            }
            const modal = document.querySelector(`#${this.name}`)
            if (modal instanceof Node) {
                modal.focus()
                if (this.onEnterKeyPress) {
                    modal.addEventListener('keypress', this.onEnterKeyPressListener)
                    // Event listeners removed automatically with unmount on close
                }
            }
        },

        onClosed() {
        },

        onEnterKeyPressListener(event) {
            const key = event.which || event.keyCode
            if (key === 13) { // Enter
                this.onEnterKeyPress()
            }
        }
    }
}
</script>

<style lang="scss">
    .modal-container {
        outline: none;
        height: 100%;
        text-align: center;
        padding: 24px;
    }

    .app-modal-header {
        color: $color-purple-light;
        margin-bottom: 20px;
        font-size: 24px;
    }

    .app-modal-content {
        min-height: 120px;
        height: calc(100% - 120px);
    }

    .app-modal-actions {
        margin-top: 20px;
    }

    label {
        color: $color-purple-light;
    }
</style>
